var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4748 9.30001L14.6998 6.45001C15.0748 6.07501 15.4498 5.32501 15.4498 4.72501V3.07501C15.4498 2.25001 14.7748 1.57501 13.9498 1.57501H4.0498C3.2248 1.57501 2.5498 2.25001 2.5498 3.15001V4.87501C2.5498 5.32501 2.8498 6.00001 3.2248 6.37501L6.0748 9.37501C6.3748 9.75001 6.6748 10.425 6.6748 10.95V14.925C6.6748 16.125 8.02481 16.8 8.9998 16.2L10.0498 15.525",
    stroke: "#292D32",
    strokeWidth: 1.09,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11.5H15",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13.5H13",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.e49bdcb3a281d1cf00956d1b5e1578a0.svg";
export { ForwardRef as ReactComponent };